import React from 'react';
import ActionButton from "../../Components/Buttons/ActionButton";
import StandardModal from "./StandardModal";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../Redux/GlobalReducer";

const ConfirmationModal = (props) => {
    const dispatch = useDispatch();

    const openModals = useSelector(state => state.global.openModals);

    const getModalProps = () => {
        if (openModals.hasOwnProperty(props.modalKey)) {
            let modalState = openModals[props.modalKey];
            if (typeof modalState === 'object' && modalState !== null) {
                return modalState;
            }
        }
        return {};
    }

    const isOpen = () => {
        if (props.open) {
            return true;
        }

        if (openModals.hasOwnProperty(props.modalKey)) {
            return true;
        }

        return false;
    }

    const handleCancel = (event) => {
        if (props.onCancel) {
            props.onCancel(getModalProps());
        }

        if (props.modalKey) {
            dispatch( hideModal(props.modalKey) )
        }

        if (props.onClose) {
            props.onClose( getModalProps() );
        }
    }

    const handleConfirm = (event) => {
        if (props.onConfirm) {
            props.onConfirm(getModalProps(), event);
        }

        if (props.modalKey) {
            dispatch( hideModal(props.modalKey) )
        }

        if (props.onClose) {
            props.onClose(getModalProps(), event);
        }
    }

    const getButtons = () => {
        if (props.useYesNoConfirmation) {
            return [
                <button
                    type="button"
                    className="button secondary width-1"
                    onClick={handleCancel}
                >No
                </button>,
                <ActionButton
                    type="button"
                    className="button primary width-1"
                    onClick={handleConfirm}
                    animateOnClick
                    title="Yes"
                />
            ];
        } else {
            let buttons = [];

            if (props.cancelText) {
                buttons.push(
                    <button
                        type="button"
                        className="button secondary"
                        onClick={handleCancel}
                    >
                        {props.cancelText}
                    </button>
                );
            }

            if (props.confirmText) {
                buttons.push(
                    <ActionButton
                        type="button"
                        className="button primary"
                        onClick={handleConfirm}
                        animateOnClick={props.animateOnConfirm}
                        title={props.confirmText}
                    />
                )
            }
            return buttons;
        }
    }

    return (
        <StandardModal
            title={props.title}
            message={props.message}
            buttons={getButtons()}
            open={isOpen()}
            onClose={handleCancel}
            style={{
                minWidth: 400,
                minHeight: '4vh'
            }}

        ></StandardModal>
    )
}

ConfirmationModal.propTypes = {
    key: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    open: PropTypes.bool,
    cancelText: PropTypes.any,
    confirmText: PropTypes.any,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    onClose: PropTypes.func,
    useYesNoConfirmation: PropTypes.bool,
    animateOnConfirm: PropTypes.bool,
}

ConfirmationModal.defaultProps = {
    title: 'Confirmation',
    cancelText: null,
    confirmText: 'Confirm',
    useYesNoConfirmation: false,
    animateOnConfirm: false,
}

export default ConfirmationModal;
